module.exports = __webpack_public_path__ + "static/media/Landing-2.f1248c4f.jpg";